import { render, staticRenderFns } from "./ModalAbstencoes.vue?vue&type=template&id=05133502&scoped=true"
import script from "./ModalAbstencoes.vue?vue&type=script&lang=js"
export * from "./ModalAbstencoes.vue?vue&type=script&lang=js"
import style0 from "./ModalAbstencoes.vue?vue&type=style&index=0&id=05133502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05133502",
  null
  
)

export default component.exports